var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.037,
    height: 88.922,
    viewBox: "0 0 100.037 88.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_135460",
    "data-name": "Path 135460",
    d: "M55.019,10C27.394,10,5,29.906,5,54.461S27.394,98.922,55.019,98.922A54.055,54.055,0,0,0,84.457,90.4l20.58,8.524L96.763,78.947a40.823,40.823,0,0,0,8.274-24.486C105.037,29.906,82.643,10,55.019,10ZM35.845,71.134V65.576S41.4,63.083,41.4,60.019A11.115,11.115,0,1,1,52.518,48.9C52.518,60.019,44.181,71.134,35.845,71.134Zm27.232,0V65.576s5.558-2.493,5.558-5.558A11.115,11.115,0,1,1,79.75,48.9C79.75,60.019,71.414,71.134,63.077,71.134Z",
    transform: "translate(-5 -10)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientReview);
export default __webpack_public_path__ + "static/media/clientReview.8c8c66ff57411cd548d9b89f75df0729.svg";
export { ForwardRef as ReactComponent };